export function CancelIdleCallback() {
    window.cancelIdleCallback = window.cancelIdleCallback ||
        function (id) {
            clearTimeout(id);
        };
}
//# sourceMappingURL=CancelIdleCallback.js.map